// extracted by mini-css-extract-plugin
export default {"formWrapper":"styles_formWrapper__OoCLU","formHeader":"styles_formHeader__1nEV2","formBody":"styles_formBody__svAc1","formFooter":"styles_formFooter__+Elwm"};